<!--
  Иконка груза: коробка/посылка.
  Обычно используется в блоках данных о грузе и грузовых местах.
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M21 16V8C21 7.28564 20.619 6.62563 20 6.26795L13 2.26795C12.381 1.91068 11.619 1.91068 11 2.26795L4 6.26795C3.38104 6.62563 3 7.28564 3 8V16C3 16.7144 3.38104 17.3744 4 17.7321L11 21.7321C11.619 22.0893 12.381 22.0893 13 21.7321L20 17.7321C20.619 17.3744 21 16.7144 21 16Z"
      :stroke="stroke"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M3.3 7L12 12L20.7 7M12 22V12"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "CargoIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
